import React from "react";
import "./../Styles/workdescription.css";

function clean(value) {
  if (value === null || value === undefined) return "";

  const text = String(value).trim();

  return ["", "null", "undefined", "n/a", "-"].includes(text.toLowerCase())
    ? ""
    : text;
}

function withMillimetres(value) {
  const text = clean(value);
  if (!text) return "";

  // Add units only when the value is a plain number.
  return /^\d+(\.\d+)?$/.test(text) ? `${text} mm` : text;
}

export default function WorkDescription({
  work,
  designTypes = [],
}) {
  if (!work) return null;

  const id = clean(work.id);
  const height = withMillimetres(work.height);
  const area = clean(work.area);
  const colours = clean(work.color);

  const types = Array.isArray(designTypes)
    ? designTypes.map(clean).filter(Boolean)
    : [];

  const overview = [
    `This embroidery work request${id ? `, reference ${id},` : ""}
    provides specifications for designers preparing a quotation.`,
    types.length
      ? `The selected design types are ${types.join(", ")}.`
      : "",
    "Review the reference images and the requester’s description to understand the required design before submitting a bid.",
  ]
    .filter(Boolean)
    .join(" ");

  const specifications = [
    height ? `The requested height is listed as ${height}.` : "",
    area ? `The area specification is listed as ${area}.` : "",
    colours ? `The listed colour count is ${colours}.` : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <section className="work-description" aria-label="Work request overview">
      <span className="work-description__label">
        EMBROIDERY WORK GUIDE
      </span>

      <h2>About this work request{id ? ` — ${id}` : ""}</h2>

      <p>{overview}</p>

      {specifications && (
        <>
          <h3>Requested specifications</h3>
          <p>{specifications}</p>
        </>
      )}

      <h3>Review the design requirements</h3>

      <p>
        Compare the reference images with the requested measurements
        and design types. Confirm the measurement units, fabric,
        intended placement, machine configuration, and required file
        format with the requester. Clarify any missing information
        before committing to the work.
      </p>

      <h3>Prepare your quotation</h3>

      <p>
        Consider the design’s complexity, digitizing time, finishing
        requirements, and any sample preparation when deciding your
        bid. Agree on the delivery deadline, included revisions, and
        final files. Review the platform commission shown in the bid
        window when calculating your quote.
      </p>

      <h3>Check the final design</h3>

      <p>
        Before delivery, review dimensions, stitch sequence, density,
        colour changes, and trims as applicable to the requested work.
        Where a stitching sample is part of the agreement, use the
        intended fabric and suitable backing to check alignment and
        finishing.
      </p>

      <p className="work-description__note">
        Submitting a bid is a quotation for the work request.
        Confirm acceptance, scope, delivery, and payment arrangements
        before starting the work.
      </p>
    </section>
  );
}